import { useIntl } from '@/intl'
import { useSelectFilter } from '@/scopes/search/search/domain/hooks'
import { getFilterAISelection } from '@/scopes/search/search/infrastructure/store/selectors'
import { useSearchStoreSelector } from '@/scopes/search/search/infrastructure/store/useSearchStore'
import { Token, Typography } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'

export function NumberOfRoomsTokens() {
  const intl = useIntl()
  const { isFetching, isLoading, selectedOption, selectedValue, setSelection } = useSelectFilter('RoomCount')
  const aiSelectedValue = useSearchStoreSelector(getFilterAISelection, 'RoomCount') as string

  const handleRemoveClick = React.useCallback(() => {
    setSelection(undefined)
  }, [setSelection])

  if (isLoading)
    return null
  if (!selectedOption)
    return null

  return (
    <Token value={selectedValue} disabled={isFetching} dismissible onDismissClick={handleRemoveClick} icon={aiSelectedValue === selectedValue ? 'Ai' : undefined}>
      <Typography $variant="body-m-bold-tight">
        {intl.formatMessage({
          id: 'filter_chips_number_of_rooms_prefix',
        })}
        :
      </Typography>
      {' '}
      {selectedOption.name}
    </Token>
  )
}
